import * as THREE from "three";

function fullscreenTriangleImpl() {
  const geometry = new THREE.BufferGeometry();
  const vertices = new Float32Array([-1, -1, 3, -1, -1, 3]);
  const uvs = new Float32Array([0, 0, 2, 0, 0, 2]);

  geometry.setAttribute("position", new THREE.BufferAttribute(vertices, 2));
  geometry.setAttribute("uv", new THREE.BufferAttribute(uvs, 2));

  // HINT: Fixes bounding sphere error because for some reason
  // the latest version of THREE does not like position attributes
  // with a count of 2 (center.z and radius are NaN in this case)
  geometry.boundingSphere = {
    center: new THREE.Vector3(1, 1, 0),
    radius: 0,
  };

  return geometry;
}

export const fullscreenTriangle = fullscreenTriangleImpl();

export function planeFitPerspectiveCamera(plane, camera, relativeZ = null) {
  const cameraZ = relativeZ !== null ? relativeZ : camera.position.z;
  const distance = cameraZ - plane.position.z;

  const vFov = (camera.fov * Math.PI) / 180;

  const scaleY = 2 * Math.tan(vFov / 2) * distance;
  const scaleX = scaleY * camera.aspect;

  const x = Math.abs(scaleX);
  const y = Math.abs(scaleY);

  // plane.scale.set(x, y, 1);

  return { x, y, distance };
}

export function movePlaneInFrontOfCamera({
  camera,
  width,
  height,
  isBG = true,
}) {
  let cameraDir = new THREE.Vector3();

  return function (plane) {
    let aspect = width / height;
    let h = 1;
    if (aspect < 1.0) {
      h *= aspect;
    }
    //const distance = camera.position.z - plane.position.z;
    //const distance = (h * 0.5) / Math.tan(camera.fov * 0.5 * (Math.PI / 180));

    // let vFov = (camera.fov * Math.PI) / 180;
    // let scaleY = 2 * Math.tan(vFov) * distance;
    // let scaleX = scaleY * aspect;

    camera.getWorldDirection(cameraDir);

    const { x, y, distance } = planeFitPerspectiveCamera(plane, camera);

    if (!isBG) {
      plane.position.z = 0;
      plane.rotation.setFromRotationMatrix(camera.matrix);
    } else {
      // plane.position.set(
      //   camera.position.x,
      //   camera.position.y,
      //   camera.position.z
      // );
      // plane.position.add(cameraDir.multiplyScalar(distance));
      // plane.position.z += 5;

      // TEMP:
      // plane.position.z -= 0.4;
      plane.rotation.setFromRotationMatrix(camera.matrix);
      plane.scale.set(x, y, 1);
    }
  };
}

const isFloat = (n) => Number(n) === n && n % 1 !== 0;
export const ensureShaderFloat = (num) => (isFloat(num) ? num : `${num}.0`);
